<page-header title="BUSINESS_LICENSE_PAYMENT_REPORT"></page-header>
<card>
  <form [formGroup]="form">
    <div class="field">
      <label style="font-size: 13px" class="label">{{
        'DATE_FROM' | translate
      }}</label>
      <div class="control">
        <input
          class="input is-small"
          type="date"
          formControlName="from"
          name="from"
          placeholder="Date start"
        />
      </div>
    </div>

    <div class="field">
      <label
        style="font-size: 13px"
        class="label"
        translationEditableDirective="DATE_TO"
        >{{ 'DATE_TO' | translate }}</label
      >
      <div class="control">
        <input
          class="input is-small"
          type="date"
          formControlName="to"
          name="to"
          placeholder="Date end"
        />
      </div>
    </div>
  </form>
  <button
    class="button is-info"
    [disabled]="isLoading"
    [ngClass]="{ 'is-loading': isLoading }"
    (click)="createReport()"
    translationEditableDirective="GENERATE_REPORT"
  >
    {{ 'GENERATE_REPORT' | translate }}
  </button>
</card>
